import {UI} from "../../../../stem-core/src/ui/UI";

import {AuthHelper} from "../../../AuthHelper";
import {LoadingSpinner} from "../../../ui/LoadingSpinner";


export class AuthSuccessSpinner extends LoadingSpinner {
    actionTimeout = 500;

    onMount() {
        super.onMount();
        AuthHelper.confirmedAuthenticationAction();
        setTimeout(() => {
            this.constructor.hide();
        }, this.actionTimeout);
    }
}
